import { render, staticRenderFns } from "./markets-table.vue?vue&type=template&id=0592db0f&scoped=true&"
import script from "./markets-table.vue?vue&type=script&lang=js&"
export * from "./markets-table.vue?vue&type=script&lang=js&"
import style0 from "./markets-table.vue?vue&type=style&index=0&id=0592db0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0592db0f",
  null
  
)

export default component.exports